<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-pie-chart`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22H25a1 1 0 01-1-1V2zm-4 2.4v4.104C13.1 10.28 8 16.544 8 24c0 8.837 7.163 16 16 16 7.456 0 13.72-5.1 15.496-12H43.6c-1.853 9.129-9.924 16-19.6 16-11.046 0-20-8.954-20-20 0-9.676 6.871-17.747 16-19.6zM28 20V6.446A18.026 18.026 0 0141.554 20H28z"/></svg>
</template>
<script>

export default {
  name: 'IconPieChart',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
